import React, { useState, useEffect } from "react";
import { useSubMenu } from "../../constants/data";

export default function SubMenu(props) {
  const [position, setPosition] = useState();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = (e) => {
      let moving = e.target.documentElement.getBoundingClientRect().top;
      if (moving < -180) {
        setVisible(position > moving);
      }
      setPosition(moving);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [position]);

  const isShow = visible ? "header-hidden" : "header-visible";

  const subMenu = useSubMenu();

  return (
    <div
      className={`submenu-header bg-white h-14 sm:h-[90px] shadow-lg sticky top-0 flex items-center justify-center px-3 lg:px-20 ${isShow}`}
    >
      <ul className="flex gap-8 justify-start lg:justify-center absolute w-11/12 lg:w-full overflow-x-auto items-center">
        {subMenu.map((menu) => {
          return (
            menu.product.includes(props.item[0].link) && (
              <li
                className="text-[#81838C] flex-shrink-0 text-base pb-1 cursor-pointer hover:text-black after:bg-gray-700 after:absolute after:h-0.5 after:w-0 after:bottom-0 after:left-0 hover:after:w-3 after:transition-all after:duration-300 relative"
                key={menu.id}
              >
                <a href={`#${menu.link}`}>{menu.name}</a>
              </li>
            )
          );
        })}
      </ul>
    </div>
  );
}
